module.exports = __webpack_public_path__ + "img/pic-barry-lonsen.caa48b5c.jpg";